import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Company } from "@lhd/types";

type InitialState = {
  company: Company | null;
  companyLogin: Company | null;
};

const initialState: InitialState = {
  company: null,
  companyLogin: null,
};

const companySlice = createSlice({
  name: "company",
  initialState,
  reducers: {
    setCompany(state, action: PayloadAction<{ company: Company }>) {
      state.company = action.payload.company;
    },
    setCompanyLogin(state, action: PayloadAction<{ companyLogin: Company }>) {
      state.companyLogin = action.payload.companyLogin;
    },
  },
});

export const { setCompany, setCompanyLogin } = companySlice.actions;

export default companySlice;
